module.exports = __webpack_public_path__ + "static/tpp-icon-camera-roll-5580ed6ae62c8803254f6904edc18613.png";